import { html } from 'lit';
import { query, customElement } from 'lit/decorators.js';
import { WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_APPLICATION_RULES_FORM } from '../../../../../../../../../../webcomponents.constants';
import { translateFn } from '../../../../../../../../../../utils/translator.helper';
import { styles } from '../view/styles';
import { GzFormFieldWebComponent } from '../../../../../../../../../../ui/gzForm/formField';
import { GzInputWebComponent } from '../../../../../../../../../../ui/gzInput/component/GzInputWebComponent';
import { RequiredValidator } from '../../../../../../../../../../ui/gzForm/validators/required.validator';
import { FormGroup } from '../../../../../../../../../../ui/gzForm/formGroup/form-group';
import { InputWidthValues } from '../../../../../../../../../../ui/gzInput';
import { GzPolicyFullPageWindowFormWebComponent } from '../../../../../../../../../common/policyPanel/uiSettings/dialogs/fullPage/form';
import { ContentControlApplicationRule, ModuleId, SectionId } from '@nirvana/shared/dtos/types/policies/common';
import { FontSizes } from '../../../../../../../../../../types/common/types';
import { getSupportLinkForPlatform } from '../../../../../../../utils/links';
import { GzSchedulerWebComponent } from '../../../../../../../../../../ui/gzScheduler';
import _ from 'lodash';
import { CustomizableValidator } from '../../../../../../../../../../ui/gzForm/validators/customizable.validator';
import { GzSchedulerPermission, SchedulerValue } from '../../../../../../../../../../ui/gzScheduler/types';

@customElement(WEB_COMPONENT_POLICY_PANEL_CONTENT_CONTROL_APPLICATION_RULES_FORM)
export class GzContentControlApplicationRulesFormWebComponent extends GzPolicyFullPageWindowFormWebComponent<ContentControlApplicationRule> {
  @query('#name-field')
  private nameField: GzFormFieldWebComponent<GzInputWebComponent, string>;
  @query('#scheduler-field')
  private schedulerField: GzFormFieldWebComponent<GzSchedulerWebComponent>;

  public constructor(value?: ContentControlApplicationRule) {
    super(value);
  }

  static get styles() {
    return styles;
  }

  public setError(error: string) {
    this.nameField.setError(error);
  }

  protected getConvertedFormValue() {
    const formValue = this.formGroup.value;
    const schedulerFormValue = _.get(formValue, 'scheduler') as SchedulerValue;
    _.set(formValue, 'permission', schedulerFormValue.permission);
    _.set(formValue, 'scheduler', schedulerFormValue.schedule);

    return formValue;
  }

  createFormGroup(): void {
    this.nameField.Validators = [RequiredValidator(translateFn('Required field'))];
    this.schedulerField.Validators = [
      CustomizableValidator((value: SchedulerValue) => {
        if (value.permission === GzSchedulerPermission.ALLOW_ALL) {
          return {
            valid: false,
            error: translateFn('Select at least one interval.'),
          };
        }

        return { valid: true };
      }),
    ];

    this.formGroup = FormGroup.build({
      appPath: this.nameField,
      scheduler: this.schedulerField,
    });
  }

  setFormGroupValue() {
    if (!this.value) {
      return;
    }

    this.formGroup.value = {
      appPath: this.value.appPath,
      scheduler: {
        permission: this.value.permission,
        schedule: this.value.scheduler,
      },
    };
  }

  /**
   * Render specific content.
   */
  protected renderContent() {
    return html`
      <div class="rules-form-container">
        <gz-title fontWeight="600" fontSize="11" class="module-subtitle">${translateFn('Details')}</gz-title>
        <gz-form-field id="name-field" class="label-mw-250 mt-2" label="${translateFn('Application')}" required>
          <gz-input
            inputWidth="${InputWidthValues.LARGE}"
            gz-form-input
            placeholder="${translateFn('Application path')}"
          ></gz-input>
          <gz-link
            fontSize="${FontSizes.PARAGRAPH_12}"
            href="${getSupportLinkForPlatform(
              { moduleId: ModuleId.CONTENT_CONTROL, sectionId: SectionId.CONTENT_CONTROL_WEB },
              ['suggestionList']
            )}"
            >${translateFn('View list of suggestions')}</gz-link
          >
          <gz-input-error></gz-input-error>
        </gz-form-field>

        <gz-title fontWeight="600" fontSize="11" class="module-subtitle">${translateFn('Access scheduler')}</gz-title>
        <gz-form-field id="scheduler-field" class="mt-2">
          <gz-scheduler label="${translateFn('Permissions')}" gz-form-input></gz-scheduler>
        </gz-form-field>
      </div>
    `;
  }
}
